import React from 'react';
import '../App.css';


import MedalCeremonyGraduateeCard from '../components/MedalCeremonyGraduateeCard';


//medals 
import ArmySeaDuty from '../images/Medals/Army Sea Duty.svg'
import ArmyGoodConduct from '../images/Medals/Army Good Conduct.svg'
import ArmyCommendation from '../images/Medals/Army Commendation.svg'

function HallOfFame() {

    return (
        <>
            <br />
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                <hr class="my-2" />
                <h3>Hall of Fame</h3>
                <h1>503rd Battalion</h1>
                <hr class="my-4" />
            </div>

            <div style={{display: "flex", flexDirection: "column", marginLeft: "15%", marginRight: "15%"}}>
                <h3>Medal Ceremony</h3>
                <div className="row" style={{display: "flex", flexDirection: "row"}}>  
                        <MedalCeremonyGraduateeCard image={ArmyCommendation} username="Noay_HD1" tags={["Activity", "Loyality", "Sigmaity", "Some other stuff", "Noay is better than all enlisteds"]}/>
                        
                </div>
            </div>
            
        </>
    );
}

export default HallOfFame;